export const BASE_URL = "https://asia-south1-shehrullah-khidmat-bot-v1.cloudfunctions.net/api"; // Replace with your actual API endpoint
// export const BASE_URL = "http://127.0.0.1:5001/shehrullah-khidmat-bot-v1/asia-south1/api"; // Replace with your actual API endpoint

export const getCoordinatorDetails = async (email) => {
  const phone = email?.split('@')[0];
  const response = await fetch(`${BASE_URL}/coordinator?phoneNumber=${phone}`);
  if (!response.ok) throw new Error("Failed to fetch coordinator details");
  return response.json();
};

export const getVolunteerList = async (date, venueId, serviceId) => {
  const response = await fetch(`${BASE_URL}/date/get-volunteer-list?date=${date}&venueId=${venueId}&serviceId=${serviceId}`);
  if (!response.ok) throw new Error("Failed to fetch volunteer list");
  return await response.json();
};

export const updateVolunteersStatus = async (venueId, serviceId, date, volunteers, status) => {
  const response = await fetch(`${BASE_URL}/date/update-volunteers-status`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ venueId, serviceId, date, volunteers, status }),
  });
  if (!response.ok) throw new Error("Failed to update volunteers status");
  return await response.json();
};

export const getDatesByYear = async (year) => {
  const response = await fetch(`${BASE_URL}/date/get-dates-by-year/${year}`);
  if (!response.ok) throw new Error("Failed to fetch all dates");
  return await response.json();
};

export const getCoordinatorsByService = async (serviceId) => {
  const response = await fetch(`${BASE_URL}/coordinator/get-coordinators-by-service?serviceId=${serviceId}`);
  if (!response.ok) throw new Error("Failed to fetch coordinators");
  return await response.json();
};


export const getVolunteerStats = async () => {
  const response = await fetch(`${BASE_URL}/date/volunteer-stats`);
  if (!response.ok) throw new Error("Failed to fetch volunteer statistics");
  return await response.json();
};

// export const getVolunteerList = async (venue, service) => {
//   const response = await fetch(`${BASE_URL}/getVolunteerList?venue=${venue}&service=${service}`);
//   if (!response.ok) throw new Error("Failed to fetch volunteer list");
//   return await response.json();
// };

// export const saveAttendance = async (volunteerId, status) => {
//   const response = await fetch(`${BASE_URL}/saveAttendance`, {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify({ volunteerId, status }),
//   });
//   if (!response.ok) throw new Error("Failed to save attendance");
//   return await response.json();
// };
